export default "__VITE_ASSET__r511UR3l__"